import { render, staticRenderFns } from "./CourseOrderList.vue?vue&type=template&id=25273dec&scoped=true&"
import script from "./CourseOrderList.vue?vue&type=script&lang=js&"
export * from "./CourseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./CourseOrderList.vue?vue&type=style&index=0&id=25273dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25273dec",
  null
  
)

export default component.exports